import React, { useEffect, useState } from 'react';
import { Table, Alert, Spinner,Row,Col,Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaDownload,FaTrash } from 'react-icons/fa';
import { postData, postDataLogin } from '../ApiServices/ApiService';
import NavHeader from './NavHeader';

import { Form, Button } from 'react-bootstrap';
const ClientsPage = () => {
  const [data, setData] = useState([]);
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
  const [selectCategory,setSelectCategory]=useState('');
  const [validated, setValidated] = useState(false);
  

  useEffect(() => {
    getClientList()
  }, [])

  const addingCategoryField = (data)=>{
    const filteredJobs = data.map((job) => {
      const clientName = job && job.client_category && job.client_category;
    
      if (!clientName) {
        // If client_category is empty, add "TECHNOLOGY"
        console.log('clientName',clientName)
        job.client_category = "TECHNOLOGY";
      }
    
      return job;
    }).filter((job) => {
      // Filter the jobs based on your criteria (e.g., matching event)
      return job.client_category && job.client_category.includes(data);
    });
    console.log('filteredJobs',filteredJobs)
    setData(data);

  }
  const getClientList = async () => {
    const payload = {
      "user_id": aminInfo?.user_id
    }
    setLoading(true);
    try {
      await postData('admin_in/clients/clients-list', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                addingCategoryField(respData.dataJ)
                // setData(respData.dataJ);
                setLoading(false);
                //setSuccess(resp.info);
              } else {
                setLoading(false);
                setSuccess(respData.info);
              }

            } else if (respData.statusCode === 500) {
              setLoading(false);
              setSuccess(respData.info);
            } else {
              setLoading(false);
              setSuccess('Job Details failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            console.log('resp status else if : ', resp.status);
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              setLoading(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
          }
        }).catch((error) => {
          setSuccess('Network Error');
          console.log('network error:', error);
          setLoading(false);
        });
      }).catch((error) => {
        setLoading(false);
        setSuccess('JobDetails failed. Please check your credentials or Network Error');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false);
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }

  }
  const [selectedOption, setSelectedOption] = useState(10);

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    setCurrentPage(1)
  }

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = selectedOption; // Set the number of items per page

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const pageRange = 2; // Number of page buttons to show on each side of the current page

  const getPageRange = () => {
    const start = Math.max(1, currentPage - pageRange);
    const end = Math.min(totalPages, currentPage + pageRange);

    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'Selected':
        return 'green';
      case 'Pending':
        return 'blue';
      case 'Rejected':
        return 'red';
      default:
        return 'black'; // default color, you can change it as needed
    }
  };




  const YourComponent = ({ job, index }) => {
let formattedDate;
const originalDateString = job?.created_on.substring(0, 10);

if (originalDateString) {
    const date = new Date(originalDateString);
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    formattedDate = date.toLocaleDateString(undefined, {
      timeZone: userTimeZone,
      day: '2-digit',
      month: 'short', // 'short' will give you the abbreviated month name like 'Jun'
      year: 'numeric'
    }).replace(/,/g, '')
    .replace(/\s/g, '-'); 
}
    return (
      <tr key={index}>
        <td style={{ paddingLeft: '15px', textAlign: 'end' }}>{index + 1}</td>
        <td>{job?.client_name}</td>
        <td style={{textTransform:'capitalize'}}>{job?.client_category?.toLowerCase()}</td>
        <td>{formattedDate} </td>
        {job?.client_status === 1 ? <td >Active</td> : <td>InActive</td>}
        <td style={{cursor:"pointer"}} onClick={() => handleDelete(job)}><FaTrash /></td>

      </tr>
    );
  };

  const [showModal, setShowModal] = useState(false);
  const [clientNameToDelete, setClientNameToDelete] = useState('');
  const [clientSuccess, setClientSuccess] = useState('')
  const [clientError, setClientError] = useState('')

  const handleDelete = async (clientId) => {
    setLoading(true)
    setShowModal(true);
    setClientSuccess('');
    setClientNameToDelete(clientId.client_name);

    const shouldDelete = window.confirm(`Are you sure you want to delete ${clientId.client_name}?`);
    if (!shouldDelete) {
      setLoading(false);
        return;
    }
    
    const payload = {
      "company_id": clientId.company_id,
      "client_id": clientId.client_id
    }
    console.log("payload" ,payload)
    try {
      await postData('admin_in/clients/clients-delete', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setShowModal(false);
                // addingCategoryField(respData.dataJ)
                // setData(respData.dataJ);
                setLoading(false);
                setClientSuccess(respData.info);
                setTimeout(() => {
                  setClientSuccess('');
                }, 5000);
                setData(data.filter(client => client.client_id !== clientId.client_id));
                setClientNameToDelete('');
              } else {
                setLoading(false);
                setClientError(respData.info);
              }

            } else if (respData.statusCode === 500) {
              setLoading(false);
              setClientError(respData.info);
            } else {
              setLoading(false);
              setClientError('Client Delete failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            console.log('resp status else if : ', resp.status);
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              setLoading(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
          }
        }).catch((error) => {
          setClientError('Network Error');
          console.log('network error:', error);
          setLoading(false);
        });
      }).catch((error) => {
        setLoading(false);
        setClientError('Client Delete failed. Please check your credentials or Network Error');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false);
      // Handle login error, e.g., display an error message to the user.
      console.error('Client Delete failed', error);
    }
};

const handleShow = (clientId) => {
  setClientNameToDelete(clientId.client_name);
  console.log("clientNameToDelete",clientNameToDelete);
  setShowModal(true);
};

const handleClose = () => {
  setShowModal(false);
};

  const [clientName, setClientName] = useState('')
  const handleInputChange = (event) => {
    setClientName(event.target.value)
  }

  const handleSubmit = async () => {
    console.log("event",selectCategory)
    setClientSuccess('');
    setClientError('');
    if(!selectCategory){
      setClientError("Please Enter a Category"); return
    }
    if (!clientName) {
      setClientError("Please Enter a Name"); return
    }
    if (clientName.length < 3) {
      setClientError("Enter Name Min 3 Characters"); return
    }

    const isClientExists = data.some(client => client.client_name.toLowerCase() === clientName.toLowerCase());
    if (isClientExists) {
      setClientError("Client already exists"); return
    }

    const payload = {
      "client_name": clientName,
      "admin_id": aminInfo?.user_id,
      "client_category":selectCategory
    }
    setLoading(true);
    try {
      await postData('admin_in/clients/clients-add', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setClientSuccess(respData.info);
                getClientList();
                setClientName('');
                setTimeout(() => {
                  setClientSuccess('');
                }, 5000);
              } else {
                setLoading(false);
                setClientError(respData.info);
              }

            } else if (respData.statusCode === 500) {
              setLoading(false);
              setClientError(respData.info);
            } else {
              setLoading(false);
              setClientError('client add failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403) {
            console.log('resp status else if : ', resp.status);
            setLoading(false)
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              setLoading(false);
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
          }
        }).catch((error) => {
          setClientError('Network Error');
          console.log('network error:', error);
          setLoading(false);
        });
      }).catch((error) => {
        setLoading(false);
        setClientError('client add failed. Please check your credentials or Network Error');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false);
      setClientError('client add failed. Please check your credentials or Network Error');
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  }
  

  const handleChange = (e) => {
    setSelectCategory(e.target.value);
    console.log("event",selectCategory)
  };

  return (
    <>
      {/* <div>
   <Form onSubmit={handleSubmit}>
  <div className='screen-styling' style={{ marginBottom: '10px'}}>
    <Form.Group controlId="formClientName" style={{ marginBottom: '10px' }}>
      <Form.Control
        type="text"
        name="clientName"
        placeholder="Enter Client Name*"
        value={clientName}
        onChange={(e) => setClientName(e.target.value)}
        required
      />
      <Form.Control.Feedback type="invalid">Please Enter A Client Name.</Form.Control.Feedback>
    </Form.Group>
  </div>
  <div>
   <Button type="submit" variant="dark" className="Button" style={{ width: 200, marginTop: '10px' }}>
    Submit
  </Button>

  </div>
</Form>
    </div> */}
      <div><NavHeader /></div><div className='dashboard-div'>
        <div className='client-page-div'>
          <div className='page-title-heading'>Registered Clients List</div>
          {/* {clientSuccess && <div className='error-msg'> {clientSuccess} </div>} */}
          
          <div style={{ marginBottom: 7, display: 'flex' }} className='client-button-container'>
            <div style={{ flex: 'auto' }}>
  
            <select name="selectCategory" value={selectCategory} onChange={handleChange} required  className='input-box-style'>
              <option value=""> Select Category</option>
              <option value="TECHNOLOGY">Technology</option>
              <option value="HOSPITALITY">Hospitality</option>
              <option value="HEALTH_CARE">Health Care</option>
            </select >
             
              <input
                type="text"
                value={clientName}
                onChange={handleInputChange}
                placeholder='Enter Client Name'
                className='input-box-style'
              />
              <Button variant='dark' style={{ marginBottom: 7, width: 75 }} onClick={handleSubmit}>Add</Button>
            </div>
          </div>
          {clientSuccess && <div className='success-msg' style={{ marginBottom: 5 }} > {clientSuccess}
          </div>}
          {clientError && <div className='error-msg' style={{ marginBottom: 5 }} > {clientError}
          </div>}

          {loading && (
            <div className="spinner-overlay">
              <Spinner animation="border" role="status">
                <span className="sr-only"></span>
              </Spinner>
            </div>
          )}
          {success && <Alert variant="danger">{success}</Alert>}
          <div className="table-responsive">{currentItems.length > 0 && (<div className='tables-div-response'>

            <Table striped bordered hover>
              <thead>
                <tr style={{ backgroundColor: '#EDF2FB' }}>
                  <th style={{ textAlign: 'end', color: '#345687' }}>##</th>
                  <th style={{ color: '#345687' }}>Client Name</th>
                  <th style={{ color: '#345687' }}>Client Category</th>
                  <th style={{ color: '#345687' }}>Created On</th>
                  <th style={{ color: '#345687' }}>Status</th>
                  <th style={{ color: '#345687' }}>Action</th>

                </tr>
              </thead>
              <tbody>
                {currentItems?.map((job, index) => (
                  <YourComponent key={index} job={job} index={index + indexOfFirstItem} />
                ))}
              </tbody>
            </Table>
          </div>)}

          {/* <Modal show={showModal} >
            <Modal.Header>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete? <span style={{color: '#345687', fontSize:'20px', fontWeight:'bold'}}>{clientNameToDelete}</span></Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleDelete}>
                OK
              </Button>
            </Modal.Footer>
          </Modal> */}
          

            {/* Pagination */}
            <div style={{ display: 'flex', justifyContent: 'end' }}>
            <div className='page-select-div' style={{marginRight:'10px'}}>
              <label htmlFor="dropdown" style={{padding:'5px'}}>Clients per Page:</label>
              <select className='page-no-dropdown' id="dropdown" value={selectedOption} onChange={handleSelectChange}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="75">75</option>
                <option value="100">100</option>
              </select>
            </div>
              <button
                onClick={() => paginate(currentPage - 1)}
                className='page-nation-btn'
                disabled={currentPage === 1}
              >
                Prev
              </button>

              {getPageRange().map((page) => (
                <button
                  key={page}
                  onClick={() => paginate(page)}
                  className='page-nation-btn'
                  style={{
                    backgroundColor: page === currentPage ? '#007BFF' : 'white',
                    color: page === currentPage ? 'white' : 'black',
                  }}
                >
                  {page}
                </button>
              ))}

              <button
                onClick={() => paginate(currentPage + 1)}
                className='page-nation-btn'
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default ClientsPage;
